export const MAX_WORDS_NUM = 100000;
